module.exports = __webpack_public_path__ + "static/media/BasicLogo2.ba4cbe5a.png";